module.exports = __webpack_public_path__ + "static/media/subscriptionButton.e801061a.svg";